export default __webpack_public_path__ + "static/media/three-dots.639152e3.svg";